<!--
 * @Author: yangbobolaa 994786855@qq.com
 * @Date: 2023-10-17 15:14:09
 * @LastEditors: yangbobolaa 994786855@qq.com
 * @LastEditTime: 2023-12-12 14:27:49
 * @FilePath: \backend\src\views\pddAfterSale\components\logPopup.vue
 * @Description: 日志弹窗区域
-->

<template>
  <!--  日志弹框    -->
  <k-popup title="日志" bind="v-if" :show.sync="isShow" layout="header,body,close,mask" @after-close="close">
    <y-popup-body size="large">
      <div class="mb-2" v-loading="{ loading: isLoading }">
        <k-table :data="logList" height="calc(70vh - 55px)" :columns="initColumns()"></k-table>
      </div>
    </y-popup-body>
  </k-popup>
</template>

<script>
import { MALL_REFUND_LOG_LIST } from "@/assets/modules/pinduooApiList";

export default {
  name: "logPopup",
  data() {
    return {
      isLoading: false,
      isShow: false,
      logList: [],
      para: { refundId: "" },
    };
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.isLoading = true;
      this.$fetch({
        baseUrl: window.__CONFIG__.pinduoo_url,
        api: MALL_REFUND_LOG_LIST,
        para: { ...this.para },
      })
        .then((res) => {
          this.isLoading = false;
          this.logList = res || [];
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    /** 提取table公共样式 */
    tableStyle(w) {
      return {
        width: w ? w : 80,
        "text-align": "center",
        "white-space": "normal",
        "word-break": "break-all",
      };
    },
    //日志表格列
    initColumns() {
      return [
        { name: "创建人", style: this.tableStyle(), customRender: (row) => <div>{row.createBy ? row.createBy : "——"}</div> },
        { name: "创建时间", style: this.tableStyle(), customRender: (row) => <div>{row.createTime ? row.createTime : "——"}</div> },
        { name: "日志内容", style: this.tableStyle(), customRender: (row) => <div>{row.content ? row.content : "——"}</div> },
        { name: "操作项", style: this.tableStyle(), customRender: (row) => <div>{row.item ? row.item : "——"}</div> },
        { name: "备注", style: this.tableStyle(), customRender: (row) => <div>{row.remark ? row.remark : "——"}</div> },
      ];
    },
    close() {
      this.isShow = false;
    },
  },
};
</script>
